"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_HS_GetObjectCode = exports.SHu_HS_Objects = void 0;
exports.SHu_HS_Objects = [
    { name: "zipcodes", code: "2-11359366" },
    { name: "properties", code: "2-11273381" },
    { name: "assets", code: "2-11363911" },
    { name: "underwritings", code: "2-15822979" },
    { name: "contacts", code: "0-1" },
    { name: "companies", code: "0-2" },
    { name: "deals", code: "0-3" },
    { name: "tickets", code: "0-5" },
    { name: "notes", code: "NOTE" },
    { name: "neighborhoods", code: "2-17643252" },
];
const SHu_HS_GetObjectCode = (name) => { var _a; return ((_a = exports.SHu_HS_Objects.find((obj) => obj.name === name)) === null || _a === void 0 ? void 0 : _a.code) || ""; };
exports.SHu_HS_GetObjectCode = SHu_HS_GetObjectCode;
